import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50de86b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav-item" }
const _hoisted_2 = ["href"]
const _hoisted_3 = ["aria-expanded"]
const _hoisted_4 = ["href"]

import { nextTick, ref } from "vue";
import SvgIcon from "@/components/ui/BaseIcons/SvgIcon.vue";
import type { MobileMenuItem } from "../../types";
import arrowIcon from "../../images/down-chiv.svg";


export default /*#__PURE__*/_defineComponent({
  props: {
    item: null
  },
  emits: ["navigate"],
  setup(__props: any) {

const props = __props as { item: MobileMenuItem }




const isOpen = ref(false);
const submenu = ref<HTMLUListElement | null>(null);
const submenuHeight = ref(0);
const submenuId = `mobile-sub-menu-${props.item.name}`;

const toggleSubmenu = (): void => {
  isOpen.value = !isOpen.value;

  if (!isOpen.value) {
    submenuHeight.value = 0;
    return;
  }

  void nextTick(() => {
    submenuHeight.value = submenu.value?.scrollHeight ?? 0;
  });
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    (!__props.item.children.length && (__props.item.external || __props.item.route === '#'))
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: __props.item.href,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('navigate')))
        }, _toDisplayString(__props.item.title), 9, _hoisted_2))
      : (!__props.item.children.length)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            to: __props.item.route,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('navigate')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.item.title), 1)
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true),
    (__props.item.children.length)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createElementVNode("button", {
            class: "submenu-trigger",
            type: "button",
            "aria-expanded": isOpen.value,
            "aria-controls": submenuId,
            onClick: toggleSubmenu
          }, [
            _createElementVNode("span", null, _toDisplayString(__props.item.title), 1),
            _createVNode(SvgIcon, {
              local: "",
              class: _normalizeClass(["submenu-icon", { 'submenu-icon--open': isOpen.value }]),
              src: _unref(arrowIcon)
            }, null, 8, ["class", "src"])
          ], 8, _hoisted_3),
          _createElementVNode("ul", {
            id: submenuId,
            ref_key: "submenu",
            ref: submenu,
            class: _normalizeClass(["submenu", { 'submenu--open': isOpen.value }]),
            style: _normalizeStyle({ height: `${submenuHeight.value}px` })
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.item.children, (child) => {
              return (_openBlock(), _createElementBlock("li", {
                key: child.name,
                class: "has-bullet"
              }, [
                _createElementVNode("a", {
                  href: child.href,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('navigate')))
                }, [
                  _createElementVNode("span", null, _toDisplayString(child.title), 1)
                ], 8, _hoisted_4)
              ]))
            }), 128))
          ], 6)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})